import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ApplicationTeamForm } from '../../Forms/ApplicationTeamForm'
import { SupportTeamForm } from '../../Forms/SupportTeamForm'
import { SupportTeamRolesForm } from '../../Forms/SupportTeamRolesForm'

type MessagesApplicationsApplicationTeam = RestSchemas['Messages.Applications.ApplicationTeam']

export function RowActionsMenu({ row }: { row: MessagesApplicationsApplicationTeam }) {
  // const canEditApp = useCanEditApp()

  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="size-8 rounded-full">
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {/* <DropdownMenuItem onSelect={() => null}>Edit application</DropdownMenuItem> */}
          <ApplicationTeamForm
            selectedTeam={row}
            sheetTitle={`Edit team ► ${row.name}`}
            sheetDescription="Edit the details of the application team."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit application team</DropdownMenuItem>
            }
          />
          <ApplicationTeamForm
            delete
            selectedTeam={row}
            sheetTitle={`Delete team ► ${row.name}`}
            sheetDescription="Delete the application team."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Delete application team</DropdownMenuItem>
            }
          />
          <SupportTeamForm
            selectedSupportTeam={row}
            sheetTitle={`Maintain support team ► ${row.name}`}
            sheetDescription="Maintain the support team members."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain team members</DropdownMenuItem>
            }
          />
          <SupportTeamRolesForm
            appTeam={row}
            sheetTitle={`Maintain support team roles ► ${row.name}`}
            sheetDescription="Maintain the support team roles."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain team roles</DropdownMenuItem>}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
